import { render, staticRenderFns } from "./clientOverview_EditActivityFeedback.vue?vue&type=template&id=f516e496&scoped=true&"
import script from "./clientOverview_EditActivityFeedback.vue?vue&type=script&lang=js&"
export * from "./clientOverview_EditActivityFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f516e496",
  null
  
)

export default component.exports